import type { IncomeSplitConfigLegacy } from '@fruitful/income-split';

import { requestBuilder } from '../../http/RequestBuilder';

const useGetProposedLegacyIncomeSplit = requestBuilder.query<
    IncomeSplitConfigLegacy,
    { moneyMapId: string }
>({
    endpoint: ({ moneyMapId }) =>
        `/api/money-map/${moneyMapId}/income-split-legacy`,
    queryKey: ({ moneyMapId }) =>
        `useGetProposedLegacyIncomeSplit/${moneyMapId}`,
});

export default useGetProposedLegacyIncomeSplit;
